import { TableRow, TableCell } from '../ui/Table';
import { EmptyState } from '../ui/EmptyState';

// ----------------------------------------------------------------------

export interface TableNoDataProps {
  isNotFound: boolean;
  isFiltered?: boolean;
  noDataText?: string;
}

export default function TableNoData({ isNotFound, isFiltered, noDataText }: TableNoDataProps) {
  if (!isNotFound) {
    return null;
  }

  return (
    <TableRow className="table-row-empty">
      <TableCell colSpan={12}>
        <EmptyState
          variant={isFiltered ? 'search' : 'default'}
          title={isFiltered ? 'No results found' : noDataText || 'No data'}
          description={
            isFiltered
              ? 'Try adjusting your search or filter to find what you are looking for.'
              : noDataText
              ? undefined
              : 'There is no data to display.'
          }
          className="py-12"
        />
      </TableCell>
    </TableRow>
  );
}
